import { Controller } from "@hotwired/stimulus"

// Client-side text filter over a list: hides item targets whose text doesn't
// match the input. Usage:
//   <div data-controller="list-filter">
//     <input data-list-filter-target="input" data-action="input->list-filter#filter">
//     <tr data-list-filter-target="item">…</tr>
export default class extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    this.itemTargets.forEach((item) => {
      item.hidden = query !== "" && !item.textContent.toLowerCase().includes(query)
    })
  }
}
